import { render, staticRenderFns } from "./GenerarInvitacionesView.vue?vue&type=template&id=6ef539d6"
import script from "./GenerarInvitacionesView.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerarInvitacionesView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports